import { Bell, FileText, Hammer, Mail, MessageSquare, Phone, Syringe, type LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

/**
 * Lucide icon names that `options.icon` may hold. Add a name here before using it in the database.
 * Any other non-empty value (for example a flag emoji) is rendered as literal text.
 */
const OPTION_ICONS: Record<string, LucideIcon> = {
    bell: Bell,
    "file-text": FileText,
    hammer: Hammer,
    mail: Mail,
    "message-square": MessageSquare,
    phone: Phone,
    syringe: Syringe,
};

export function isLucideOptionIcon(name: string | null | undefined): name is keyof typeof OPTION_ICONS {
    return Boolean(name && name in OPTION_ICONS);
}

export function renderOptionIcon(name: string | null | undefined): ReactNode {
    if (!name) return null;
    const Icon = OPTION_ICONS[name];
    if (Icon) {
        return <Icon className="size-4 shrink-0" aria-hidden />;
    }
    return (
        <span className="text-base leading-none shrink-0" aria-hidden>
            {name}
        </span>
    );
}
